<template>
  <div class="tags">
    <el-tag :key="tag"
            v-for="tag in dynamicTags"
            closable
            :disable-transitions="false"
            @close="handleClose(tag)">
      {{tag}}
    </el-tag>
    <el-input class="input-new-tag"
              v-if="inputVisible"
              v-model="inputValue"
              ref="saveTagInput"
              @blur="handleInputConfirm">
    </el-input>
    <el-button class="button-new-tag"
               v-else
               size="medium"
               @click="showInput">+ 新增</el-button>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dynamicTags: [],
      inputVisible: false,
      inputValue: ''
    };
  },
  mounted () {
    this.getTags()
  },
  methods: {
    getTags () {
      let dataId = JSON.parse(window.localStorage.getItem("dwform")).dataId
      let params = {
        dataId: dataId
      }
      this.$http({
        method: "get",
        url: this.$Api.getTags,
        params,
      }).then((result) => {
        console.log('result :>> ', result);
        let res = result.data.tags
        if (res !== "") {
          this.dynamicTags = res.split(",")
        }

      }).catch((err) => {

      });
    },
    handleClose (tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
      let tags = this.dynamicTags.join(',')
      let params = {
        dataId: JSON.parse(window.localStorage.getItem("dwform")).dataId,
        tags: tags
      }
      this.$http({
        method: "get",
        url: this.$Api.modifyTags,
        params,
      }).then((result) => {
        if (result.data.errcode == 0) {
          this.$message({
            message: '删除成功',
            type: 'success'
          });
        } else {
          this.$message.error('删除失败');
        }
      }).catch((err) => {

      });
    },
    showInput () {
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm () {
      let inputValue = this.inputValue;
      if (inputValue.length > 0 && inputValue.length < 17) {
        this.dynamicTags.push(inputValue);
      } else {
        this.$message.error('请输入不大于10个字的标签');
        this.inputVisible = false;
        this.inputValue = '';
        return
      }
      let tags = this.dynamicTags.join(',')
      let params = {
        dataId: JSON.parse(window.localStorage.getItem("dwform")).dataId,
        tags: tags
      }
      this.$http({
        method: "get",
        url: this.$Api.modifyTags,
        params,
      }).then((result) => {
        if (result.data.errcode == 0) {
          this.$message({
            message: '添加成功',
            type: 'success'
          });
        } else {
          this.$message.error('添加失败');
        }
      }).catch((err) => {

      });
      this.inputVisible = false;
      this.inputValue = '';
    }
  },
}
</script>

<style lang="less" scoped>
.tags {
  width: 80%;
  display: flex;
  padding: 10px 0 0 10px;
  flex-wrap: wrap;
  /deep/.el-tag {
    background: linear-gradient(to right, rgb(49, 68, 211), rgb(88, 192, 250));
    color: rgb(255, 255, 255);
    font-size: 16px;
    padding: 0 16px;
    height: 40px;
    line-height: 40px;
    border: none;
    box-shadow: 0 2px 6px 1px hsla(0, 0%, 61.2%, 0.45098039215686275);
    transition: all 0.4s ease-in-out;
    border-radius: 8px;
    float: left;
    margin-top: 10px;
    margin-left: 10px;
    &:hover {
      margin-top: 0px;
    }
  }
  /deep/.el-tag__close {
    color: #fafc14;
    transition: all 0.4s ease-in-out;
    font-size: 15px;
    height: 16px;
    width: 20px;
    line-height: 16px;
    &:hover {
      background: none;
      transform: rotate(90deg);
    }
  }

  .button-new-tag {
    float: left;
    height: 40px;
    width: 130px;
    line-height: 40px;
    padding-top: 0;
    padding-bottom: 0;
    padding: 0 30px;
    font-size: 16px;
    color: #fff;
    border-radius: 8px;
    border: none;
    box-shadow: 0 2px 4px 1px hsla(0, 0%, 61.2%, 0.45098039215686275);
    transition: all 0.3s ease-in-out;
    margin-top: 10px !important;
    margin-left: 10px !important;
    background: linear-gradient(to right, rgb(163, 71, 223), rgb(95, 203, 249));
    &:hover {
      margin-top: 0px !important;
    }
  }
  .input-new-tag {
    float: left;
    width: 130px;
    height: 40px;
    line-height: 40px;
    margin-left: 10px;
    vertical-align: bottom;
    margin-top: 10px;
    /deep/.el-input__inner {
      border-radius: 8px;
      &:focus {
        border-color: #a347df;
      }
    }
  }
}
</style>